export const ListCardImageSvg = () => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.375 2.25h6.5a.75.75 0 01.692.462l3.125 7.5A.75.75 0 0118 11.25h-1.875v1.281a1.875 1.875 0 11-1.5 0V11.25h.757H11.6h.776v5.312A4.501 4.501 0 0116.125 21v.75h-9V21c0-2.23 1.622-4.08 3.75-4.438V11.25H5.25a.75.75 0 01-.692-1.039l3.125-7.5a.75.75 0 01.692-.461zm7.375 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-9.375-4.5l2.5-6h5.5l2.5 6h-10.5zm2.345 10.5a3.001 3.001 0 015.81 0H8.72z"
      fill="#8B91A1"
    />
  </svg>
);
